export default "__VITE_ASSET__yxYr0zUz__"